import styled from "styled-components";
import ImgChecked from "../../../../styles/assets/img/icon_radio_checked.png";

export const InputRadioBox = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const InputRadioIcon = styled.div`
  width: 14px;
  height: 14px;
  border: 1px solid ${(props) => props.theme.colors.black12};
  border-radius: 50%;
`;

export const InputRadioLabel = styled.label`
  display: flex;
  width: 100%;
  height: 32px;
  padding: 0 12px;
  color: ${(props) => props.theme.colors.black30};
  font-size: 1.2rem;
  white-space: nowrap;
  border: 1px solid ${(props) => props.theme.colors.black12};
  border-radius: 6px;
  align-items: center;
  gap: 8px;

  input {
    display: none;
  }

  &:has(input:checked) {
    color: ${(props) => props.theme.colors.primary100};
    font-weight: 600;
    border-color: ${(props) => props.theme.colors.primary100};
    background: ${(props) => props.theme.colors.primary6};

    ${InputRadioIcon} {
      border: none;
      background: url(${ImgChecked});
      background-size: cover;
    }
  }
`;
